const theme = {
  primary: '#4EBA9A',
  secondary: '#CFCF22',
  disabled: '#C8C8C8',
  background: '#F8F2E1',
};

export default theme;
